import useModalDOM from "helpers/hooks/useModalDOM";
import useScrollToTop from "helpers/hooks/useScrollToTop";
import useScrollAnchor from "helpers/hooks/useScrollAnchor";
export default function Documents({ children }) {
  useScrollToTop();
  useScrollAnchor();
  useModalDOM();

  return children;
}
